import {
  AddOnFeeCategory,
  AddOnFees,
  FeeCalculationType,
  IContractDetailsResponseData,
} from "../api/services/contract/models";

export const getShipmentFeesTotal = (
  contract?: IContractDetailsResponseData
) => {
  if (!contract?.addonFeesList?.length || contract?.itemPrice == null) return 0;
  const addonShippingFees = contract?.addonFeesList?.filter(
    (fee) => fee.type === AddOnFeeCategory.SHIPPING_FEES
  );
  const total =
    addonShippingFees?.reduce?.((acc: number, addOnFee: AddOnFees) => {
      if (addOnFee.feeType === FeeCalculationType.FLAT) {
        return acc + addOnFee.amount;
      } else if (addOnFee.feeType === FeeCalculationType.PERCENTAGE) {
        return acc + (contract?.itemPrice * addOnFee.amount) / 100;
      }
      return acc;
    }, 0) ??
    contract?.shipment?.fee ??
    0;
  return total;
};
